// extracted by mini-css-extract-plugin
export default {"release-notes-collapsible":"x_cb","header-collapsible":"x_cc"};